import React from "react";
import bg from '../Images/Hero-bg.png';
import bg2 from '../Images/Hero-bg02.png';
import logo from '../Images/logo.png'; 
import { FaPhoneAlt } from "react-icons/fa";
import { FaQuoteLeft } from "react-icons/fa";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col">
      <header className="w-full bg-white bg-opacity-90 text-white px-6 md:px-16 py-3 flex items-center justify-between z-20 relative">
        <div className="flex items-center">
          <img src={logo} alt="Logo" className="h-10 md:h-12 object-contain" />
        </div>
        <div>
          <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-5 rounded-full transition duration-300 flex items-center gap-2">
            <FaPhoneAlt className="text-white w-4 h-4" />
            +91 9023330002
          </button>
        </div>
      </header>

      {/* Hero Background */}
      <div className="relative flex-1 flex items-center justify-center px-6 md:px-16">
        {/* Background Images */}
        <div
          className="absolute inset-0 bg-cover bg-center hidden md:block"
          style={{ backgroundImage: `url(${bg})` }}
        ></div>
        <div
          className="absolute inset-0 bg-cover bg-center block md:hidden"
          style={{ backgroundImage: `url(${bg2})` }}
        ></div>

        {/* Dark Overlay for text visibility */}
        <div className="absolute inset-0 bg-black bg-opacity-25 md:bg-opacity-25"></div>
        {/* Stronger overlay for smaller devices */}
        <div className="absolute inset-0 bg-black bg-opacity-50 md:hidden"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl text-center md:text-left text-white md:ml-[300px] pt-5 md:pt-0 mt-80 md:mt-0">
          <span className="text-5xl text-whhite md:text-[#3f4a2f] inline-block">
            <FaQuoteLeft />
          </span>
          <p className="text-3xl md:text-5xl font-bold leading-snug text-white md:text-black ">
            A healthy diet isn't about restriction, <br />
            it's about freedom—
          </p>
          <p className="mt-4 text-lg md:text-2xl text-white md:text-black">
            freedom from disease, fatigue, and limits.
          </p>
          <p
            className="mt-6 text-xl italic text-white md:text-black"
            style={{ fontFamily: "'Dancing Script', cursive" }}
          >
            Niharika Jain
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
